'use client'

import AppIcon from "@/app/components/atomic/AppIcon"

export default function ScrollToTopButton() {
    const handleScrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <button
            className="border border-blue-900 rounded-xl py-[25px] text-blue-900 cursor-pointer flex items-center gap-1.5 w-full justify-center"
            onClick={handleScrollToTop}
        >
            <AppIcon className="text-xs pr-1.5 w-4" type="regular" iconClassName="fa-arrow-up" />
            Revenir en haut de page
        </button>
    )
}

